export const CURRENCIES = [
  { value: 'USD', label: '$ USD - US Dollar' },
  { value: 'EUR', label: '\u20AC EUR - Euro' },
  { value: 'GBP', label: '\u00A3 GBP - British Pound' },
  { value: 'KES', label: 'KSh KES - Kenyan Shilling' },
  { value: 'TZS', label: 'TSh TZS - Tanzanian Shilling' },
  { value: 'UGX', label: 'USh UGX - Ugandan Shilling' },
  { value: 'NGN', label: '\u20A6 NGN - Nigerian Naira' },
  { value: 'GHS', label: 'GH\u20B5 GHS - Ghanaian Cedi' },
  { value: 'ZAR', label: 'R ZAR - South African Rand' },
  { value: 'AED', label: 'AED - UAE Dirham' },
  { value: 'SAR', label: 'SAR - Saudi Riyal' },
  { value: 'INR', label: '\u20B9 INR - Indian Rupee' },
  { value: 'CNY', label: '\u00A5 CNY - Chinese Yuan' },
  { value: 'JPY', label: '\u00A5 JPY - Japanese Yen' },
  { value: 'AUD', label: 'A$ AUD - Australian Dollar' },
  { value: 'CAD', label: 'C$ CAD - Canadian Dollar' },
  { value: 'CHF', label: 'CHF - Swiss Franc' },
  { value: 'SEK', label: 'kr SEK - Swedish Krona' },
  { value: 'NOK', label: 'kr NOK - Norwegian Krone' },
  { value: 'DKK', label: 'kr DKK - Danish Krone' },
  { value: 'PLN', label: 'z\u0142 PLN - Polish Zloty' },
  { value: 'BRL', label: 'R$ BRL - Brazilian Real' },
  { value: 'MXN', label: 'MX$ MXN - Mexican Peso' },
  { value: 'COP', label: 'COP - Colombian Peso' },
  { value: 'ARS', label: 'ARS - Argentine Peso' },
  { value: 'CLP', label: 'CLP - Chilean Peso' },
  { value: 'PEN', label: 'S/ PEN - Peruvian Sol' },
  { value: 'KRW', label: '\u20A9 KRW - South Korean Won' },
  { value: 'SGD', label: 'S$ SGD - Singapore Dollar' },
  { value: 'HKD', label: 'HK$ HKD - Hong Kong Dollar' },
  { value: 'TWD', label: 'NT$ TWD - Taiwan Dollar' },
  { value: 'THB', label: '\u0E3F THB - Thai Baht' },
  { value: 'MYR', label: 'RM MYR - Malaysian Ringgit' },
  { value: 'IDR', label: 'Rp IDR - Indonesian Rupiah' },
  { value: 'PHP', label: '\u20B1 PHP - Philippine Peso' },
  { value: 'VND', label: '\u20AB VND - Vietnamese Dong' },
  { value: 'PKR', label: 'Rs PKR - Pakistani Rupee' },
  { value: 'BDT', label: '\u09F3 BDT - Bangladeshi Taka' },
  { value: 'EGP', label: 'E\u00A3 EGP - Egyptian Pound' },
  { value: 'MAD', label: 'MAD - Moroccan Dirham' },
  { value: 'TND', label: 'TND - Tunisian Dinar' },
  { value: 'ETB', label: 'Br ETB - Ethiopian Birr' },
  { value: 'RWF', label: 'RF RWF - Rwandan Franc' },
  { value: 'XAF', label: 'FCFA XAF - CFA Franc (Central)' },
  { value: 'XOF', label: 'CFA XOF - CFA Franc (West)' },
  { value: 'BWP', label: 'P BWP - Botswana Pula' },
  { value: 'MWK', label: 'MK MWK - Malawian Kwacha' },
  { value: 'ZMW', label: 'ZK ZMW - Zambian Kwacha' },
  { value: 'MZN', label: 'MT MZN - Mozambican Metical' },
  { value: 'TRY', label: '\u20BA TRY - Turkish Lira' },
  { value: 'RUB', label: '\u20BD RUB - Russian Ruble' },
  { value: 'UAH', label: '\u20B4 UAH - Ukrainian Hryvnia' },
  { value: 'ILS', label: '\u20AA ILS - Israeli Shekel' },
  { value: 'QAR', label: 'QAR - Qatari Riyal' },
  { value: 'KWD', label: 'KWD - Kuwaiti Dinar' },
  { value: 'BHD', label: 'BHD - Bahraini Dinar' },
  { value: 'OMR', label: 'OMR - Omani Rial' },
  { value: 'JOD', label: 'JOD - Jordanian Dinar' },
  { value: 'LKR', label: 'Rs LKR - Sri Lankan Rupee' },
  { value: 'NPR', label: 'Rs NPR - Nepalese Rupee' },
  { value: 'MMK', label: 'K MMK - Myanmar Kyat' },
  { value: 'NZD', label: 'NZ$ NZD - New Zealand Dollar' },
];

export function getCurrencySymbol(code: string): string {
  const map: Record<string, string> = {
    USD: '$', EUR: '\u20AC', GBP: '\u00A3', KES: 'KSh', TZS: 'TSh', UGX: 'USh',
    NGN: '\u20A6', GHS: 'GH\u20B5', ZAR: 'R', INR: '\u20B9', CNY: '\u00A5', JPY: '\u00A5',
    AUD: 'A$', CAD: 'C$', CHF: 'CHF', BRL: 'R$', MXN: 'MX$', KRW: '\u20A9',
    SGD: 'S$', HKD: 'HK$', TRY: '\u20BA', RUB: '\u20BD', ILS: '\u20AA',
    PHP: '\u20B1', THB: '\u0E3F', PLN: 'z\u0142', ETB: 'Br', RWF: 'RF',
  };
  return map[code] ?? code;
}
